import { useQuery } from '@tanstack/react-query';
import { requestSegments } from '../segments/segments';
import { ContactsSegmentsResponse } from '../segments/types/ContactsSegmentsResponse';

export function useSegments() {
    return useQuery<ContactsSegmentsResponse[], Error>({
        queryKey: ['segments'],
        queryFn: async ({ signal }) => await requestSegments(signal),
    });
}
